/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Compare_PronunciationInputs */

const en_why_listening_compare_pronunciation = /** @type {(inputs: Why_Listening_Compare_PronunciationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronounces difficult words`)
};

const es_why_listening_compare_pronunciation = /** @type {(inputs: Why_Listening_Compare_PronunciationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronuncia palabras difíciles`)
};

/**
* | output |
* | --- |
* | "Pronounces difficult words" |
*
* @param {Why_Listening_Compare_PronunciationInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_compare_pronunciation = /** @type {((inputs?: Why_Listening_Compare_PronunciationInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Compare_PronunciationInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_compare_pronunciation(inputs)
	return en_why_listening_compare_pronunciation(inputs)
});